module.exports = __webpack_public_path__ + "static/media/ambrosia.aaf69b14.jpg";